export default {
      id: "notifications__input_alert-usage",
      viewBox: "0 0 92.69 88.18",
      url: __webpack_public_path__ + "img/icons.svg#notifications__input_alert",
      toString: function () {
        return this.url;
      }
    }